var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AnimatedAudioBars"},_vm._l((_vm.bars),function(bar,index){return _c('div',{key:index,staticClass:"AnimatedAudioBars__bar",style:({
      backgroundColor: _vm.active ? '#00ffdc' : '#B6BEC7',
      height: _vm.barHeight(index)
    })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }